import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { withStyledAttrs } from '../../helpers/styled';
import Text from '../Text';
import Config from '../../config';
export var Wrapper = withTheme(styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-10asd06-0"
})(["margin:", ";", ";"], function (p) {
  return p.coreTheme.accordion.margin;
}, Config.media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: ", ";\n  "])), function (p) {
  return p.coreTheme.accordion.mdMargin;
})));
export var TitleWrapper = withTheme(styled.div.withConfig({
  displayName: "style__TitleWrapper",
  componentId: "sc-10asd06-1"
})(["display:flex;justify-content:space-between;align-items:center;cursor:pointer;user-select:none;"]));
export var IconWrapper = withTheme(styled.div.withConfig({
  displayName: "style__IconWrapper",
  componentId: "sc-10asd06-2"
})(["align-self:flex-start;margin-top:", "px;"], function (p) {
  return p.coreTheme.space_2;
}));
export var TitleText = withTheme(withStyledAttrs(Text, {
  type: 'boldBody'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n    margin-right: ", "px;\n\n    ", ";\n  "])), function (p) {
  return p.coreTheme.cl_ter_base;
}, function (p) {
  return p.coreTheme.space_4;
}, Config.media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin-right: ", "px;\n    "])), function (p) {
  return p.coreTheme.space_6;
})));
export var TextWrapper = withTheme(styled.div.withConfig({
  displayName: "style__TextWrapper",
  componentId: "sc-10asd06-3"
})(["color:", ";font-family:", ";"], function (p) {
  return p.coreTheme.cl_ter_base;
}, function (p) {
  return p.coreTheme.ff_sec_thin;
}));